
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.18 0h3.54l-7.73 8.84 9.1 12.03h-7.13l-5.58-7.3L4 20.87H.46l8.27-9.46L0 0h7.3l5.04 6.67L18.18 0zm-1.24 18.75h1.96L6.24 2.01h-2.1l12.8 16.74z","fill":"#1F4053"}})])
          )
        }
      }
    